import React from 'react';
import { Grid, Paper, Typography, Box, useTheme } from '@mui/material';
import { PieChart } from '@mui/x-charts';
import { reportsMockData } from '../../data/reportsMockData';
import { createChartGradients } from './utils/chartUtils';

export const CaseDistributionCharts: React.FC = () => {
  const theme = useTheme();

  const pieChartConfig = {
    height: 250, // Reduced height
    margin: { top: 0, bottom: 0 },
    slotProps: {
      legend: {
        hidden: true,
      },
    },
  };

  const pieSeriesConfig = {
    innerRadius: 80,
    outerRadius: 120,
    paddingAngle: 2,
    cornerRadius: 4,
    highlightScope: { faded: 'global', highlighted: 'item' },
    arcLabelMinAngle: 45,
    arcLabel: (params: any) => `${params.value}`,
    arcLabelStyle: {
      fill: '#ffffff', // Using hex for white
      fontSize: 14,
      fontWeight: 'bold',
      dominantBaseline: 'middle',
      textAnchor: 'middle',
      pointerEvents: 'none', // Prevent text from interfering with hover
    },
    cx: 175,
    cy: 125,
  };

  const statusChartData = reportsMockData.statusDistribution.map((item, index) => ({
    ...item,
    id: `status-${index}`,
    color: `url(#status-gradient-${index})`,
  }));

  const practiceAreaChartData = reportsMockData.practiceAreaDistribution.map((item, index) => ({
    ...item,
    id: `practice-${index}`,
    color: `url(#practice-gradient-${index})`,
  }));

  return (
    <>
      <Grid item xs={12} md={6}>
        <Paper 
          sx={{ 
            p: 3,
            height: '100%',
            minHeight: 300, // Reduced minimum height
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>Case Status Distribution</Typography>
          <Box sx={{ 
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: 250, // Fixed height to match chart
          }}>
            <PieChart
              series={[{
                data: statusChartData,
                ...pieSeriesConfig,
              }]}
              {...pieChartConfig}
              width={350}
            >
              {createChartGradients(reportsMockData.statusDistribution, 'status')}
            </PieChart>
          </Box>
        </Paper>
      </Grid>

      <Grid item xs={12} md={6}>
        <Paper 
          sx={{ 
            p: 3,
            height: '100%',
            minHeight: 300, // Reduced minimum height
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>Cases by Practice Area</Typography>
          <Box sx={{ 
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: 250, // Fixed height to match chart
          }}>
            <PieChart
              series={[{
                data: practiceAreaChartData,
                ...pieSeriesConfig,
              }]}
              {...pieChartConfig}
              width={350}
            >
              {createChartGradients(reportsMockData.practiceAreaDistribution, 'practice')}
            </PieChart>
          </Box>
        </Paper>
      </Grid>
    </>
  );
};